import * as Contentful from 'contentful'

import { TypeComponentCtaButton } from './component-cta-button'
import { TypeVariationContainerAuthAndDeviceTypeCta } from './variation-container-auth-and-device-type-cta'

export enum CtaGroupLayout {
  Row = 'Default: Row',
  Column = 'Column',
}

export interface TypeItemCtaGroupFields {
  internalName: Contentful.EntryFields.Symbol
  layout: CtaGroupLayout
  ctAs: TypeComponentCtaButton[] | TypeVariationContainerAuthAndDeviceTypeCta[]
}

export type TypeItemCtaGroup = Contentful.Entry<TypeItemCtaGroupFields>
